"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2 8a1 1 0 112 0 1 1 0 01-2 0zm3.83-1a3.001 3.001 0 100 2h4.34a3.001 3.001 0 100-2H5.83zM13 7a1 1 0 100 2 1 1 0 000-2z"];
//# sourceMappingURL=one-to-one.js.map